import {ReportName} from 'common/report/constants';
import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';

import {CohortDetail} from '../create-cohort-button';

export enum TabOptions {
  USER_LIST = `USER_LIST`,
  USER_DETAIL = `USER_DETAIL`,
}

export interface UserSidebarJsxProps {
  attrs: {
    'hide-cohort-functionality'?: boolean;
    'include-all-users': boolean;
    segments: string[];
    'segment-label'?: string;
    'report-name': ReportName;
    color?: string;
    'data-group-name'?: string;
    'from-date'?: string;
    'to-date'?: string;
  };
  props: {
    cohort: Cohort;
    cohortDetails: CohortDetail[];
  };
  state: {
    cohort: Cohort;
    cohortDetails: CohortDetail[];
    selectedTab: TabOptions;
    distinctID: string;
  };
}
